import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  UpdateResearchLibCategoryBodyT,
  UpdateResearchLibCategoryResT,
} from 'server/controllers/researchLib';

import {
  P_API_RESEARCH_LIB_CATEGORY,
  type ResearchLibCategoryT,
  getConfig,
} from 'utils';

type UpdateResearchLibCategoryArgT = {
  id: string;
  name: string;
};

export async function updateResearchLibCategory({
  id,
  name,
}: UpdateResearchLibCategoryArgT): Promise<ResearchLibCategoryT> {
  assertClientSide();

  const config = await getConfig();

  const res = await axios.patch<UpdateResearchLibCategoryResT>(
    `${P_API_RESEARCH_LIB_CATEGORY}/${id}`,
    {
      _csrf: config.CSRF,
      name,
    } satisfies UpdateResearchLibCategoryBodyT,
  );

  return res.data;
}
